"use strict";
require('./CompanyDeviationWatcherService.js');

CompanyDeviationWatcherListCtrl.$inject = [
  '$scope',
  '$stateParams',
  'growl',
  '$translate',
  'deviationWatchers',
  'CompanyDeviationWatcherService'
];

function CompanyDeviationWatcherListCtrl(
  $scope,
  $stateParams,
  growl,
  $translate,
  deviationWatchers,
  CompanyDeviationWatcherService
) {
  $scope.deviationWatchers = deviationWatchers;
  $scope.more = false;
  $scope.page = parseInt($stateParams.page, 10) || 1;
  
  if($scope.deviationWatchers.length === 21) {
     $scope.more = true;
     $scope.deviationWatchers.pop();
   }

  $scope.remove = function(deviationWatcher, index) {
  	CompanyDeviationWatcherService.delete({companyId: $stateParams.companyId, deviationWatcherId: deviationWatcher.id}, function() {
      growl.addSuccessMessage($translate.instant('deviation.remove-deviation-watcher-success'));
      $scope.deviationWatchers.splice(index, 1);
    },
    function() {
      growl.addErrorMessage($translate.instant('deviation.remove-deviation-watcher-failure'));
    });
  };
}

CompanyDeviationWatcherListCtrl.resolve = {
  deviationWatchers: ['CompanyDeviationWatcherService', '$stateParams', function(CompanyDeviationWatcherService, $stateParams) {
  	var page      = parseInt($stateParams.page, 10) || 1;
    var filter    = {
      companyId: $stateParams.companyId,
      limit:     21,
      offset:    (page - 1) * 20
    };
    return CompanyDeviationWatcherService.query(filter).$promise;
  }]
};

module.exports = CompanyDeviationWatcherListCtrl;

angular.module('dokiv')
  .controller('CompanyDeviationWatcherListCtrl', CompanyDeviationWatcherListCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/deviation-watchers/CompanyDeviationWatcherListCtrl.js
// module id = 339
// module chunks = 0